
import { AppProvider, Layout } from "@shopify/polaris";
import { useEffect, useState } from "react";
import {Helmet} from "react-helmet";

import React from "react";
import enTranslations from "@shopify/polaris/locales/en.json";
import { getAppInfo, getAppReview } from "../../../services/seller/api";
import { useParams } from "react-router-dom";
import Fotter from "../../../layout/fotter";
import PartnerBanner from "../../../seller_components/partner_section/partner_banner";
import AppRating from "../../../components/interface/app_review_interface";
import '../app_details/app_details.scss'
import AppDetailSkeleton from "../../../skeleton/AppDetailSkeleton";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import AboutThisApp from "../../../components/app_details/about";
import Features from "../../../components/app_details/features";
import Plans from "../../../components/app_details/plans";
import Ratings from "../../../components/app_details/rating";
import CardBanner from "../../../components/app_details/top_cards";
import { captureGAEvent, gaPanelConfig } from "../../../shared/helper";
import { useSelector } from "react-redux";

export default function AppInfo() {
    const [appData, setAppData] = useState<any>();
    const [isSkeletonVisible, setIsSkeletonVisible] = useState(false);
    const { slug } = useParams();
    const [isPopupOpen, setPopupOpen] = useState(false);
    const auth = useSelector((state: any) => state.auth);
    const [apiRefresh, setApiRefresh] = useState(false);
    const handleInstallClick = () => {
        setPopupOpen(true);
    };
   

    useEffect(() => {
        
        const fetchData = async () => {
            try {
                const appInfoResponse = await getAppInfo(slug);
                setAppData(appInfoResponse.data);



            } catch (error) {
                console.error("Error fetching data:", error);
            } finally {
                setIsSkeletonVisible(false);
            }
        };
        // if (auth.token && !apiRefresh) {
          
      
        //     console.log("refresh all apps data")
        //     fetchData();
        //     setApiRefresh(true)
         
        //   }
        
        fetchData();
    }, [slug,auth.token]);

    const sendGAEvent = (event: string) => {
        captureGAEvent(event, event);
    };

    useEffect(() => {
        if (isPopupOpen) {
            handleInstallClick();
        }
        else {
            console.log('')
        }
    }, [isPopupOpen]);

    if (!appData) {
        return <AppDetailSkeleton />;
    }


    ///this is use for global login 
    localStorage.setItem('slug', appData.slug);
    return (
        <>
            {!isSkeletonVisible && (
                <div className="main-container">
                     <Helmet>
                <meta charSet="utf-8" />
                <title>App Store | {slug}</title>
             
            </Helmet>
                    {/* <ToastContainer /> */}
                    <div style={{ paddingTop: "150px", minWidth: '-webkit-fill-available' }} >
                        <div style={{ background: "#fbfafd" }}>
                            <div className="container">
                                <CardBanner appData={appData} />
                                <AboutThisApp appData={appData} />
                                <div style={{ height: "30px" }}></div>
                            </div>
                        </div>

                        {appData.app_info.features !== null ? (
                            <div style={{ background: "#fafbfe" }}>
                                <Features appData={appData} />
                            </div>
                        ) : (
                            <div></div>
                        )}

                        <div style={{ background: "#fcfcfd" }}>

                            <Plans appData={appData} />

                        </div>

                        <div style={{ background: "#fcfcfd" }}>

                            <Ratings appData={appData} />

                        </div>


                        {/* <div >
                            <div style={{ background: "#fcfcfd", margin: '0px' }} >
                                <PartnerBanner />
                            </div>

                        </div> */}

                    </div>
                </div>
            )
            }
             <div style={{ marginBottom: "20px" }} className="container">
              <PartnerBanner />
            </div>
            <Fotter />
        </>
    )
}